module.exports = __webpack_public_path__ + "71faee6e2e89438d05545b935d878bff.png";